var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExportTopright = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 9,
  fill: "none",
  viewBox: "0 0 18 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#00A32E",
  d: "M.174.389v1.078h16.241v6.777h1.249V.378z"
})));
export { SvgExportTopright as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE4IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjE3MzgyOCAwLjM4ODc5N1YxLjQ2NjU3SDE2LjQxNVY4LjI0NDM1SDE3LjY2MzZWMC4zNzc2ODZMMC4xNzM4MjggMC4zODg3OTdaIiBmaWxsPSIjMDBBMzJFIi8+Cjwvc3ZnPgo=";